import React from 'react';
import HeroHeadlineText from '../HeroHeadlineText';

import './bilateralCardInfo.scss';
import TextComponent from '../TextComponent/textComponent';
import BilateralImage from '../Bilateral/BilateralImage/bilateralImage';

const BilateralCardInfo = ({ heading, imageData, textHeading, description, linksBtn, layoutStyle }) => {
  return (
    <div className={`bilateral-card-column ${heading ? 'left-column' : ''}`}>
      {heading && <HeroHeadlineText headlineText={heading} />}
      <div className="bilateral-card">
        <div className="bilateral-card-img">{imageData && <BilateralImage src={imageData} alt="bilateral-card-img" />}</div>
        <TextComponent heading={textHeading} description={description} linksBtn={linksBtn} layoutStyle={layoutStyle} />
      </div>
    </div>
  );
};

export default BilateralCardInfo;
